let variants = document.querySelector(".variants");
if (variants) {
    let variantChildren = variants.childNodes;


    let i;

    if (window.innerWidth < 992) {
        for (i = 0; i < variantChildren.length; i++) {
            let tag = String(variantChildren[i].tagName);
            let tagToLower = tag.toLowerCase();
            if (tagToLower == "span") {
                document.addEventListener('click', function (e) {
                    if (e.target.parentElement.classList.contains("variants__item")) {
                        e.preventDefault();
                    }
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/components/variants.js